package com.milta.core.localization.translations.it

import com.milta.core.localization.WebHistoriqueStrings

internal val WebHistorique = WebHistoriqueStrings(
    screenATitle = "Storico dei giri",
    periodLabel = "Periodo",
    periodLastEightDays = "Ultimi 8 giorni",
    periodSingleDate = "Data precisa",
    periodRange = "Intervallo di date",
    rangeFromLabel = "Dal",
    rangeToLabel = "Al",
    driverFilterLabel = "Corriere",
    driverFilterAllOption = "Tutti i corrieri",
    columnDate = "Data",
    columnDriver = "Corriere",
    columnTotalDeliveries = "Totale consegne",
    columnDelivered = "Consegnate",
    columnFailed = "Non riuscite",
    viewProofsAction = "Vedi le prove",
    emptyHistoryMessage = "Nessun giro trovato per questo periodo.",
    errorInvalidPeriod = "Il periodo selezionato non è valido.",
    screenBTitle = "Storico delle prove di consegna",
    routeOfLabel = "Giro del",
    totalDeliveriesLabel = "consegne",
    deliveredLabel = "consegnate",
    failedLabel = "non riuscite",
    backToHistoryAction = "Storico dei giri",
    statusDeliveredBadge = "Consegnato",
    statusFailedBadge = "Non riuscita",
    viewReasonAction = "Vedi il motivo",
    hideReasonAction = "Nascondi il motivo",
    photoPlaceholderAlt = "Nessuna foto disponibile",
    photoAlt = "Prova di consegna",
    emptyProofsMessage = "Nessuna prova di consegna disponibile per questo giro.",
    paginationPrevious = "Precedente",
    paginationNext = "Successivo",
)
